// src/components/Footer.jsx
import React from "react";
import "./HeaderFooter.css";

const Footer = () => (
  <footer className="custom-footer text-light text-center py-3">
    <p className="mb-0">
      &copy; {new Date().getFullYear()} <strong>Zainab Medical & Children Care Centre</strong> 🏥 — All Rights Reserved
    </p>
  </footer>
);

export default Footer;
